
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewForConsensusPage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Review"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewForDataExtractionPage"},"directives":[]}]}}],"loc":{"start":0,"end":124}};
    doc.loc.source = {"body":"#import \"./ReviewForDataExtractionPage.gql\"\n\nfragment ReviewForConsensusPage on Review {\n  ...ReviewForDataExtractionPage\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./ReviewForDataExtractionPage.gql").definitions));


      module.exports = doc;
    
